(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-style-1"] && !Shopify.designMode) return;
  try {
    
jQuery(function() {
$(document).on( 'shopify:section:select', function(){
GOODWIN.flowtype ? GOODWIN.flowtype.reinit('.bnr[data-fontratio]') : false;
// GOODWIN.initialization.hoverColor();
})
});

  } catch(e) { console.error(e); }
})();
})();
